import { useState } from "react";
// Components
import AddressForm from "./AddressForm";
// MUI
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AddressCreateDialog({ disabled }) {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        disabled={disabled}
        variant="outlined"
        // size="small"
        // sx={{ mt: 2 }}
        onClick={handleClickOpen}
      >
        New Address
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"lg"}>
        <DialogTitle>New Address</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Use the form below to create a new address.
          </DialogContentText>
          <AddressForm closeDialog={handleClose} />
        </DialogContent>
      </Dialog>
    </>
  );
}
